export function AboutCompany() {
  return (
    <div className="page">
      <section className="content-section">
        <h1>About HiPioneer Technologies</h1>
        <p>
          HiPioneer Technologies is a startup built to help ambitious businesses bring digital products to life. We combine consulting, app development, and training services so our clients can move faster, reduce risk, and build solutions that users love.
        </p>
        
        <div className="about-content">
          <div className="about-block">
            <h2>Our Mission</h2>
            <p>
              To accelerate startup and SME success by delivering practical technology solutions, product expertise, and team enablement that drive measurable results.
            </p>
          </div>

          <div className="about-block">
            <h2>Our Vision</h2>
            <p>
              To become the trusted technology partner for growing companies seeking agile development, intelligent digital transformation, and a culture of innovation.
            </p>
          </div>

          <div className="about-block">
            <h2>Our Values</h2>
            <ul>
              <li><strong>Innovation:</strong> We create modern, user-centered solutions.</li>
              <li><strong>Excellence:</strong> We deliver quality with speed and care.</li>
              <li><strong>Integrity:</strong> We build trust with openness and dependability.</li>
              <li><strong>Collaboration:</strong> We partner closely with clients and teams.</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
